export { default } from "./CompareTable";
export * from "./CompareTable";
